import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, MessageCircle } from "lucide-react";
import { apiClient } from "@/lib/api";
import { Logo } from "@/components/landing/Logo";
import { Navbar } from "@/components/landing/Navbar";
import { WHATSAPP_URL } from "@/components/landing/data";

export const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    apiClient.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white" data-testid="blog-post-page">
      <Navbar />
      <main className="mx-auto max-w-3xl px-5 pb-20 pt-[132px] sm:px-8">
        {notFound ? (
          <p className="text-[#5E6E85]" data-testid="post-not-found">Article not found.</p>
        ) : !post ? (
          <p className="text-[#5E6E85]" data-testid="post-loading">Loading...</p>
        ) : (
          <motion.article initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <div className="flex flex-wrap gap-2">
              {post.tags?.map((t) => (
                <span key={t} className="rounded-full bg-[#D4AF37]/10 px-3 py-1 text-[10px] uppercase tracking-[0.15em] text-[#A07E1F]">{t}</span>
              ))}
            </div>
            <h1 className="mt-6 font-serif-display text-3xl font-medium leading-tight tracking-tight text-[#12294D] sm:text-5xl" data-testid="post-title">
              {post.title}
            </h1>
            <p className="mt-5 border-l-2 border-[#D4AF37]/50 pl-5 font-serif-display text-lg italic text-[#46586F]">{post.excerpt}</p>
            <div className="mt-10 space-y-6" data-testid="post-content">
              {post.content.split(/\n\n+/).map((para, i) => (
                <p key={i} className="text-base leading-relaxed text-[#46586F]">{para}</p>
              ))}
            </div>
            <div className="luxury-card mt-14 flex flex-col items-start gap-5 rounded-xl p-8 sm:flex-row sm:items-center sm:justify-between" data-testid="post-cta">
              <div>
                <h3 className="font-serif-display text-2xl font-semibold text-[#12294D]">Need a hand with yours?</h3>
                <p className="mt-1 text-sm text-[#46586F]">Get a free, no-obligation quote in under 15 minutes.</p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link to="/" data-testid="post-quote-button" className="flex items-center gap-2 rounded-full bg-[#D4AF37] px-6 py-3 font-mono-accent text-[11px] font-bold uppercase tracking-[0.18em] text-[#0A1E3C] transition-colors hover:bg-[#C9A227]">
                  Get a Free Quote <ArrowRight size={14} />
                </Link>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="post-whatsapp-button" className="flex items-center gap-2 rounded-full border border-[#D4AF37]/50 px-6 py-3 font-mono-accent text-[11px] uppercase tracking-[0.18em] text-[#A07E1F] transition-colors hover:bg-[#D4AF37]/10">
                  <MessageCircle size={14} /> WhatsApp
                </a>
              </div>
            </div>
          </motion.article>
        )}
      </main>
    </div>
  );
};
